import { appEnv } from "@/constants/app-env";

type RouteValue = string | ((id: string) => string);
type Routes = Record<string, Record<string, RouteValue>>;

export const routes = {
  HOME: {
    root: "/workspaces/:workspaceId",
  },
  AUTH: {
    root: "/auth",
    callback: "/auth/callback",
    signin: "/auth/sign-in",
    signup: "/auth/sign-up",
    signupEmailVerify: "/auth/sign-up/email/verify",
    resetPassword: "/auth/reset-password",
    requestResetPassword: "/auth/request-reset-password",
    error: "/auth/error",
  },
  OAUTH: {
    paypal: "/oauth/callback/paypal",
    tiktok: "/oauth/callback/tiktok",
  },
  MUSIC: {
    root: "/workspaces/:workspaceId/music",
    dashboard: "/workspaces/:workspaceId/music/dashboard",
  },
  PAYOUT: {
    root: "/workspaces/:workspaceId/payout",
    details: "/workspaces/:workspaceId/payout/details",
    bankTransfer: "/workspaces/:workspaceId/payout/bank-transfer",
  },
  CHANNELS: {
    root: "/workspaces/:workspaceId/channels",
  },
  SETTINGS: {
    account: "/workspaces/:workspaceId/settings/account",
    workspace: "/workspaces/:workspaceId/settings/workspace",
  },
  JOIN_WORKSPACE: {
    root: "/join-workspace",
    callback: "/join-workspace/callback",
  },
  CUSTOM_MUSIC: {
    root: "/workspaces/:workspaceId/custom-music",
    dspAnalytics: "/workspaces/:workspaceId/custom-music/analytics",
  },
  NOT_FOUND: {
    root: "/not-found",
  },
  CAMPAIGNS: {
    root: "/workspaces/:workspaceId/campaigns",
    my: "/workspaces/:workspaceId/campaigns/my",
    /* @deprecated */
    views: "/workspaces/:workspaceId/campaigns/:id",
    /* @deprecated */
    _views: (id: string) => `/workspaces/:workspaceId/campaigns/${id}`,
    view: "/workspaces/:workspaceId/campaigns/:id/view",
    _view: (id: string) => `/workspaces/:workspaceId/campaigns/${id}/view`,
    detail: "/workspaces/:workspaceId/campaigns/:id/detail",
    _detail: (id: string) => `/workspaces/:workspaceId/campaigns/${id}/detail`, // NOTE: Attach _ to key to build dynamic route
    form: "/workspaces/:workspaceId/campaigns/:id/form",
    _form: (id: string) => `/workspaces/:workspaceId/campaigns/${id}/form`,
    videoSubmit: "/workspaces/:workspaceId/campaigns/:id/submit",
    _videoSubmit: (id: string) => `/workspaces/:workspaceId/campaigns/${id}/submit`,
    join: "/workspaces/:workspaceId/campaigns/:id/join",
    _join: (id: string) => `/workspaces/:workspaceId/campaigns/${id}/join`,
  },
  WORKSPACE_NAVIGATOR: {
    root: "/",
    campaigns: "/campaigns/*",
  },
} as const satisfies Routes;

export const externalUrls = {
  HELP_CENTER_ROOT_URL: "https://help.backpac.app/",
  PROMOTION_0311_URL: "https://help.backpac.app/Early-User-Exclusive-80-Revenue-Share-16656f70dfd0805db42ae62e14fcf50c",
  PRIVACY_POLICY_URL: "https://help.backpac.app/Privacy-Policy-5d0d822092d84ff5a843fe83ce7bc1a5",
  TERMS_OF_SERVICE_URL: "https://help.backpac.app/Terms-of-Service-1c4c288f38db4cb993a1f54bd7a1a73a",
  STATIC_REOUSRCE_BASE_URL: "https://static.backpac.app",
  MUSIC_RESOURCE_BASE_URL: "https://static.backpac.app/music",
  YOUTUBE_DEEPLINK_URL: "youtube://m.youtube.com/",
  YOUTUBE_SHORTS_BASE_DEEPLINK_URL: "vnd.youtube://m.youtube.com/source",
  generateYoutubeShortsDeeplink: (videoId: string) =>
    `${externalUrls.YOUTUBE_SHORTS_BASE_DEEPLINK_URL}/${videoId}/shorts`,

  PAYPAL_URL: appEnv.isDevelopment ? "https://www.sandbox.paypal.com" : "https://paypal.com",
} as const;

export const imageUrls = {
  logo: {
    desktop: `${externalUrls.STATIC_REOUSRCE_BASE_URL}/logo/logo-desktop.png`,
    desktopBlack: `${externalUrls.STATIC_REOUSRCE_BASE_URL}/logo/logo-desktop-black.png`,
    mobile: `${externalUrls.STATIC_REOUSRCE_BASE_URL}/logo/logo.png`,
  },
  workspacePlaceholder: {
    thumbnail: `${externalUrls.STATIC_REOUSRCE_BASE_URL}/images/workspace-placeholder.png`,
  },
} as const;

export function getAssetsUrl(name: string) {
  return `${externalUrls.STATIC_REOUSRCE_BASE_URL}/assets/${name}`;
}
